/*Junais  02-04-2022*/

import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../actions/secmasteractions';
import { checkAccess } from '../../../actions/securityactions';
import { getUserBranch } from '../../dashboard/actions/dashboardactions';

export default function ApplicableBrancehes() {
    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    var checkPermissions = state.checkPermissions;
    var branchMasters = state.applicableBranches.branchMasters;
    var userBranches = state.applicableBranches.userBranches;
    const refApplicableBranches = useRef(null);

    console.log("applicableBranches", branchMasters);
    console.log("userBranches", userBranches);
    useEffect(() => {
        async function checkPermissions() {
            await dispatch(checkAccess({ pageMenuId: 1 }));
        }
        checkPermissions()
        async function getUserApplicableBranches() {
            await dispatch(actions.getUserApplicableBranches());
            await dispatch(actions.resetApplicableBranches())
        }
        getUserApplicableBranches();
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [userBranches]);

    const scrollToBottom = () => {
        refApplicableBranches.current?.scrollIntoView({ behavior: 'smooth' });
    };


    /* function onRequestClose() {
        dispatch(actions.closeReport());
    } */

    function handleApplicableBranchesRadioBtnChange(value, e) {
        dispatch(actions.handleApplicableBranchesRadioBtnChange(value, e.target.checked))
    }
    function handleUserBranchesRadioBtnChange(value, e) {
        dispatch(actions.handleUserBranchesRadioBtnChange(value, e.target.checked))
    }

    /* function handleCheckBoxChange(reportId, value) {
        dispatch(actions.handleCheckBoxChange(reportId, value));
        async function getReportParams() {
            await dispatch(actions.getReportParams(reportId, state.reportOptions.uiParams));
        }
        getReportParams();
    }*/
    function resetApplicableBranches() {
        dispatch(actions.resetApplicableBranches())
    }
    function moveToUserBranches() {
        dispatch(actions.moveToUserBranches())
    }
    function removeFromUserBranches() {
        dispatch(actions.removeFromUserBranches())
    }

    function saveUserApplicableBranches() {
        dispatch(actions.saveUserApplicableBranches())
    }
    function renderSystemsBranches() {
        if (branchMasters.length == 1 && branchMasters[0].brCode == 0) {
            return <></>
        }
        return (
            <>
                {branchMasters.length > 0 && branchMasters.map((branchMaster, index) => (
                    <div className="mb-12 col-md-12" key={branchMaster.brCode}>
                        <div className="form-check form-check-inline">
                            <input type="radio" id={`customRadio_branch${branchMaster.brCode}`}
                                name={`customRadio_branch${branchMaster.brCode}`} className="form-check-input"
                                onChange={(e) => handleApplicableBranchesRadioBtnChange(branchMaster.brCode, e)}
                                checked={branchMaster.isChecked}
                                disabled={userBranches.map(ub => ub.brCode).filter(br => br == branchMaster.brCode).length > 0} />
                            <label className="form-check-label" htmlFor={`customRadio_branch${branchMaster.brCode}`}>{branchMaster.brName}</label>
                        </div>
                    </div>
                ))}
            </>
        )
    }


    function renderSelectedBranches() {
        if (userBranches.length == 0 || (userBranches.length == 1 && userBranches[0].brCode == 0)) {
            return <><div className="row g-2">
                <div className="mb-1 col-md-12">
                    {<h5 className="alert alert-danger">No branches assigned...</h5>}
                </div>
            </div></>
        }
        return (
            <>
                {userBranches.length > 0 && userBranches.map((userBranch, index) => (
                    <div className="mb-12 col-md-12" key={userBranch.brCode}>
                        <div className="form-check form-check-inline">
                            <input type="radio" id={`customRadio_user${userBranch.brCode}`}
                                name={`customRadio_user${userBranch.brCode}`} className="form-check-input"
                                onChange={(e) => handleUserBranchesRadioBtnChange(userBranch.brCode, e)}
                                checked={userBranch.isChecked} />
                            <label className="form-check-label" htmlFor={`customRadio_user${userBranch.brCode}`}>{userBranch.brName}</label>
                        </div>
                    </div>
                ))}
            </>
        )
    }
    return (
        <>
            <div className="content" ref={refApplicableBranches}>
                <div className="row">
                    <div className="col-12">
                        <div className="card ribbon-box">
                            <div className="card-body">
                                <div className="ribbon ribbon-primary float-start"><i className="dripicons-list me-1"></i>Applicable Branches</div>

                                <div class="custmcontainer">
                                    <div class="left-section">
                                        <h5>
                                            {/* <i class="dripicons-view-list"></i> */} All Branches
                                        </h5>
                                        <hr />
                                        <div className="row g-2">
                                            {renderSystemsBranches()}

                                        </div>
                                    </div>
                                    <div /* style={{ innerWidth: "2px" }} */ className='ms-5 col-md-6 mt-5 pt-5'>
                                        {checkPermissions.hasAddUserBranch && <button className='btn btn-primary mb-1 mt-5' type="button" disabled={branchMasters.filter(b => b.isChecked == true).length == 0}
                                            onClick={() => moveToUserBranches()}><i class="dripicons-chevron-right" /> </button>
                                        }
                                        <div></div>
                                        {checkPermissions.hasRemoveUserBranch && <button className='btn btn-primary' type="button" disabled={userBranches.filter(b => b.isChecked == true).length == 0}
                                            onClick={() => removeFromUserBranches()}><i class="dripicons-chevron-left" /></button>
                                        }
                                    </div>


                                    <div class="right-section">
                                        <h5>
                                            {/* <i class="dripicons-view-list"></i> */} User Branches
                                        </h5>
                                        <hr />
                                        <div className="row g-2">
                                            {renderSelectedBranches()}
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-2">
                                    <div class="modal-footer">
                                        {checkPermissions.hasResetUserBranch && <button className='btn btn-danger' type="button" onClick={() => resetApplicableBranches()}><i className="mdi mdi-rotate-left" /> Reset</button>}
                                        {checkPermissions.hasSaveUserBranch && <button className='btn btn-success' type="button" onClick={() => saveUserApplicableBranches()}><i class="dripicons-print"></i> Save</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

